module.exports = __webpack_public_path__ + "img/camioneta.a51d9d94.png";